import { List } from '@zenterprise-inc/ui';
import { graphql, useLazyLoadQuery } from 'react-relay';

import { InviteOverviewUserPromotionHistoryQuery } from '@/__generated__/InviteOverviewUserPromotionHistoryQuery.graphql';
import { INVITE_EVENT_PROMOTION_CODE } from '@/lib/constants/event';

const inviteOverviewUserPromotionHistoryQuery = graphql`
  query InviteOverviewUserPromotionHistoryQuery($promotionCode: String!) {
    getRefundUserPromotionHistory(promotionCode: $promotionCode) {
      count
    }
  }
`;

export const InviteOverview = () => {
  const userPromotionHistory = useLazyLoadQuery<InviteOverviewUserPromotionHistoryQuery>(inviteOverviewUserPromotionHistoryQuery, {
    promotionCode: INVITE_EVENT_PROMOTION_CODE
  });
  const finishCount: number = userPromotionHistory.getRefundUserPromotionHistory?.count ?? 0;

  return (
    <div className={'flex w-full flex-col items-center bg-[#F2F3F4] px-6 py-16 md:py-20'}>
      <div className={'text-[32px] font-bold leading-[1.3] md:text-[40px] lg:text-[48px]'}>내 초대 현황</div>
      <div className={'rounded-5 mt-12 w-full max-w-[520px] bg-white px-6 py-3'}>
        <List.Basic
          title={{ text: '초대 성공한 친구', color: 'gray.800', titleStyle: 'text-18 font-bold' }}
          right={{
            type: 'text',
            component: <span className={'text-14 leading-[20px] text-gray-700'}>{finishCount}명</span>
          }}
        />
      </div>
      <div className={'rounded-5 mt-12 w-full max-w-[520px] bg-white p-6'}>
        <div className={'text-18 md:text-22 flex gap-2 font-bold leading-[1.4] text-gray-900'}>
          내가 모은 스탬프<span className={'text-[#14B866]'}>{finishCount}개</span>
        </div>
        <div className={'text-15 mt-2 font-medium text-gray-700'}>지금까지 {finishCount}명의 친구가 조회 완료했어요.</div>
        <div className={'relative mt-6'}>
          <img
            src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/event/share/stamp/stamp-${(finishCount > 10 ? 10 : finishCount).toString().padStart(2, '0')}.png`}
            alt={'stamp'}
          />
          {finishCount > 10 && (
            <img
              src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/event/share/stamp/img_stamp-ed-07promo-invite.png`}
              alt={'infinite stamp'}
              className={'absolute top-0'}
            />
          )}
        </div>
      </div>
    </div>
  );
};
